export function parseContentDispositionFilename(header: string | null | undefined): string | undefined {
    if (!header) {
        return undefined;
    }

    const utf8Match = /filename\*=UTF-8''([^;\n]+)/i.exec(header);
    if (utf8Match?.[1]) {
        try {
            return decodeURIComponent(utf8Match[1].trim());
        } catch {
            // fall through to other patterns
        }
    }

    const quotedMatch = /filename="([^"]+)"/i.exec(header);
    if (quotedMatch?.[1]) {
        return quotedMatch[1];
    }

    const unquotedMatch = /filename=([^;\n]+)/i.exec(header);
    if (unquotedMatch?.[1]) {
        return unquotedMatch[1].trim();
    }

    return undefined;
}
